const DISMISS_KEY_PREFIX = 'blarkad.site_announcement.dismissed.';
const DISMISS_TTL_MS = 24 * 60 * 60 * 1000;

function storageOrNull() {
  try {
    return window.localStorage;
  } catch (_error) {
    return null;
  }
}

function announcementStorageKey(node) {
  const announcementKey = (node.dataset.siteAnnouncementKey || '').trim();
  if (!announcementKey) return null;
  return `${DISMISS_KEY_PREFIX}${announcementKey}`;
}

function removeAnnouncement(node, animated = false) {
  const wrapper = node.closest('[data-site-announcement-wrap]') || node;
  if (!animated) {
    wrapper.remove();
    return;
  }

  node.classList.add('is-closing');
  window.setTimeout(() => wrapper.remove(), 170);
}

function bindAnnouncement(node) {
  if (node.dataset.siteAnnouncementBound === '1') return;
  node.dataset.siteAnnouncementBound = '1';

  const storage = storageOrNull();
  const key = announcementStorageKey(node);
  if (storage && key) {
    const rawDismissedAt = storage.getItem(key);
    const dismissedAt = Number.parseInt(rawDismissedAt || '', 10);
    if (Number.isFinite(dismissedAt) && Date.now() - dismissedAt < DISMISS_TTL_MS) {
      removeAnnouncement(node);
      return;
    }

    if (rawDismissedAt) {
      storage.removeItem(key);
    }
  }

  const dismissButton = node.querySelector('[data-site-announcement-dismiss]');
  if (!dismissButton) return;

  dismissButton.addEventListener('click', () => {
    if (storage && key) {
      storage.setItem(key, String(Date.now()));
    }
    removeAnnouncement(node, true);
  });
}

function initSiteAnnouncementBar() {
  document.querySelectorAll('[data-site-announcement]').forEach(bindAnnouncement);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initSiteAnnouncementBar);
} else {
  initSiteAnnouncementBar();
}

document.addEventListener('turbo:load', initSiteAnnouncementBar);
document.addEventListener('turbolinks:load', initSiteAnnouncementBar);
window.addEventListener('pageshow', initSiteAnnouncementBar);
